import { render, staticRenderFns } from "./MainComp.vue?vue&type=template&id=1cac9df4&scoped=true"
import script from "./MainComp.vue?vue&type=script&lang=js"
export * from "./MainComp.vue?vue&type=script&lang=js"
import style0 from "./MainComp.vue?vue&type=style&index=0&id=1cac9df4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cac9df4",
  null
  
)

export default component.exports